import { Routes } from '@angular/router';
import { AccessoryNetworkComponent } from './accessory-network.component';

export const routes: Routes = [
  { path: ':veioid', component: AccessoryNetworkComponent },
  { path: '', component: AccessoryNetworkComponent }
];
